import axios from '../utils/axios'

export function payOrder(params) {
    return axios.get('/pay', { params })
}

export function payMode(params) {
    return axios.post('/mode', params)
}